import LanguagePicker from "../Header/LanguagePicker";
import Image from "components/Elements/Image/Image";
import { memo } from "react";
import { LinkToNewTab } from "../../Elements/Link/Link";
import { useContent } from "contexts/contentContext/contentContext";
import { useUser } from "contexts/userContext/userContext";
import { DOMAIN_NAME } from "utils/globalConsts";

import styles from "./customDomainFooter.module.scss";
import "./languagePicker.scss";

const CustomDomainFooter = memo(() => {
  const { getTextByKey, getLanguage } = useContent();
  const { isLoggedIn } = useUser();

  const baseUrlWithLang = `https://${DOMAIN_NAME}/${getLanguage()}/`;

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.logoWrapper}>
          <span className={styles.poweredByText}>
            {getTextByKey("powered-by")}
          </span>
          {/*@ts-ignore*/}
          <LinkToNewTab
            page={baseUrlWithLang + "home"}
            fullUrl
            classes={styles.logo}
          >
            <Image
              name="logo-footer"
              ext="png"
              style={{
                maxHeight: 30,
              }}
              title="JUMBOmail"
              alt="JUMBOmail"
            />
          </LinkToNewTab>
        </div>
        {/*@ts-ignore*/}
        {/* <LinkToNewTab page={baseUrlWithLang + "terms"} isNewTab fullUrl>
          {getTextByKey("terms-of-use")}
        </LinkToNewTab> */}
        {/*@ts-ignore*/}
        {/* <LinkToNewTab
          page={baseUrlWithLang + "privacy-policy"}
          isNewTab
          fullUrl
        >
          {getTextByKey("privacy-policy")}
        </LinkToNewTab> */}
        {/*@ts-ignore*/}
        {/* <LinkToNewTab page={baseUrlWithLang + "accessibility"} isNewTab fullUrl>
          {getTextByKey("accessibility")}
        </LinkToNewTab> */}
        {/*@ts-ignore*/}
        {/* <LinkToNewTab page={baseUrlWithLang + "contact-us"} isNewTab fullUrl>
          {getTextByKey("contact-us")}
        </LinkToNewTab> */}
        {/*@ts-ignore*/}
        {/* <LinkToNewTab page={baseUrlWithLang + "about"} isNewTab fullUrl>
          {getTextByKey("about-us")}
        </LinkToNewTab> */}
        {/*@ts-ignore*/}
        {/* <LinkToNewTab page={baseUrlWithLang + "support"} isNewTab fullUrl>
          {getTextByKey("support")}
        </LinkToNewTab> */}
        {navigator.userAgent === "ReactSnap" || !isLoggedIn() ? null : (
          <div>
            <LanguagePicker
              withLabel={false}
              className="bottom-language"
            ></LanguagePicker>
          </div>
        )}
      </div>
    </div>
  );
});

export default CustomDomainFooter;
